import { render, staticRenderFns } from "./DialogPOSDetail.vue?vue&type=template&id=fd218290"
import script from "./DialogPOSDetail.vue?vue&type=script&lang=js"
export * from "./DialogPOSDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports